import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { PrimaryButton } from '@bibliocommons/base-buttons';

export default function ResumeHoldButton({ handleClick, isLoading, disabled }) {
  return (
    <PrimaryButton
      isLoading={isLoading}
      disabled={disabled}
      className="cp-resume-hold-button"
      handleClick={handleClick}>
      <FormattedMessage id="resume_hold" />
    </PrimaryButton>
  );
}

ResumeHoldButton.propTypes = {
  handleClick: PropTypes.func,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/ResumeHoldButton/ResumeHoldButton.jsx